import gql from "graphql-tag";
const CREATE_OR_UPDATE_ENTITY = gql`
	mutation createOrUpdateEntity(
		$name: String!
		$data: JSON!
		$files: [BaseFileColumnInput!]
	) {
		createOrUpdateEntity(name: $name, data: $data, files: $files) {
			id
			serializedEntity
		}
	}
`;
const CREATE_OR_UPDATE_ENTITIES = gql`
	mutation createOrUpdateEntities(
		$name: String!
		$data: JSON!
		$files: [BaseFileColumnInput!]
	) {
		createOrUpdateEntities(name: $name, data: $data, files: $files) {
			id
			serializedEntity
		}
	}
`;
export {
  CREATE_OR_UPDATE_ENTITIES,
  CREATE_OR_UPDATE_ENTITY
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZW50aXR5LmpzIiwic291cmNlcyI6WyIuLi8uLi9zcmMvZ3JhcGhxbC9lbnRpdHkuanMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IGdxbCBmcm9tIFwiZ3JhcGhxbC10YWdcIjtcblxuZXhwb3J0IGNvbnN0IENSRUFURV9PUl9VUERBVEVfRU5USVRZID0gZ3FsYFxuXHRtdXRhdGlvbiBjcmVhdGVPclVwZGF0ZUVudGl0eShcblx0XHQkbmFtZTogU3RyaW5nIVxuXHRcdCRkYXRhOiBKU09OIVxuXHRcdCRmaWxlczogW0Jhc2VGaWxlQ29sdW1uSW5wdXQhXVxuXHQpIHtcblx0XHRjcmVhdGVPclVwZGF0ZUVudGl0eShuYW1lOiAkbmFtZSwgZGF0YTogJGRhdGEsIGZpbGVzOiAkZmlsZXMpIHtcblx0XHRcdGlkXG5cdFx0XHRzZXJpYWxpemVkRW50aXR5XG5cdFx0fVxuXHR9XG5gO1xuXG5leHBvcnQgY29uc3QgQ1JFQVRFX09SX1VQREFURV9FTlRJVElFUyA9IGdxbGBcblx0bXV0YXRpb24gY3JlYXRlT3JVcGRhdGVFbnRpdGllcyhcblx0XHQkbmFtZTogU3RyaW5nIVxuXHRcdCRkYXRhOiBKU09OIVxuXHRcdCRmaWxlczogW0Jhc2VGaWxlQ29sdW1uSW5wdXQhXVxuXHQpIHtcblx0XHRjcmVhdGVPclVwZGF0ZUVudGl0aWVzKG5hbWU6ICRuYW1lLCBkYXRhOiAkZGF0YSwgZmlsZXM6ICRmaWxlcykge1xuXHRcdFx0aWRcblx0XHRcdHNlcmlhbGl6ZWRFbnRpdHlcblx0XHR9XG5cdH1cbmA7XG4iXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUVZLE1BQUMsMEJBQTBCO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQWEzQixNQUFDLDRCQUE0QjtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7In0=
